<template>
  <div class="mt-2">
    <el-row>
      <el-col :span="24">
        Before
        <div class="form-group">
          <el-input type="text" v-model="field.question_before" />
        </div>
      </el-col>

      <el-col :span="24">
        {{ title }}
        <div class="form-group">
          <el-input type="textarea" v-model="field.question_text" />
        </div>
      </el-col>

      <el-col :span="24">
        After
        <div class="form-group">
          <el-input type="text" v-model="field.question_after" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: ["field", "title"],
  data() {
    return {};
  },
};
</script>

<style lang="scss">
</style>